<template>
  <div class="upload">
    <section class="toast" v-if="toastStatus">
      <div>
        <Col class="demo-spin-col" span="8">
        <Spin fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>上传中，请稍等</div>
        </Spin>
        </Col>
      </div>
    </section>

    <header>
      上传照片
    </header>
    <main>

      <div class="box" v-if="show == 0">
        <div class="imgbox" v-show="imgArr.length>0" v-for="(item,i) in imgArr" :key="i">
          <img class="imgbox_son1" :src="item" alt="">
          <img @click="remove(i)" class="imgbox_son2" src="../assets/image/remove.png" alt="">
        </div>
        <div class="cameraBox" v-show="imgArr.length<=0">
          <input type="file" id="file" accept="image/*" @change="imgChange(this)">
          <div class="cameraBox_son">
            <img src="../assets/image/camera.png" alt="">
            <div>点击拍照上传照片</div>
          </div>
        </div>
      </div>

      <div class="successBox" v-if="show == 1">
        <img src="../assets/image/bigsuccess.png" alt="">
        <p>上传成功</p>
      </div>
      <div class="failBox" v-if="show == 2">
        <img src="../assets/image/bigfail.png" alt="">
        <p>上传失败</p>
        <div @click="repetitionUpload">
          重新上传
        </div>
      </div>
    </main>
    <footer @click="submit" v-if="show == 0">
      提交
    </footer>
  </div>
</template>

<script>
export default {
  name: 'uploadAuthertication',
  data() {
    return {
      show: 0,
      imgArr: [],
      toastStatus: false,
      list: []
    }

  },
  created() {

  },
  mounted() {
    this.$Message.config({
      top: 100
    });
  },
  methods: {
    submit: function () {
      var href = window.location.href
      let sessionId = href.split('?')[1].split('&')[0];
      let userId = href.split('?')[1].split('&')[1];
      let data = {
        modeCode: "5HsKvDD6VcfbPXX5LyVfFnxi9QXWm5Xr",
        sessionId: sessionId,
        userId: userId,
        // sessionId: '01e9da98-b81f-4eea-84c1-8472302399ca',
        // userId: 'bc4a40d8-1de3-d450-7bfa-263ba14dadaa',
        data: this.list.join(',')
      };
      this.$http.post(data)
        .then(res => {
          if (res.code == 1) {
            this.show = 1;
          } else {
            that.$Message.error("提交失败");
            this.show = 2;
          }
        })
    },
    remove(index) {
      this.imgArr.splice(index, 1);
      this.list.splice(index, 1)
    },
    imgChange() {
      var href = window.location.href
      let sessionId = href.split('?')[1].split('&')[0];
      let userId = href.split('?')[1].split('&')[1];
      let obj = document.getElementById("file");
      var that = this;
      var image = obj.files[0]; //获取文件域中选中的图片
      var reader = new FileReader(); //实例化文件读取对象
      reader.readAsDataURL(image); //将文件读取为 DataURL,也就是base64编码
      that.toastStatus = true;
      reader.onload = function (ev) {
        //文件读取成功完成时触发
        var dataURL = ev.target.result; //获得文件读取成功后的DataURL,也就是base64编码
        that.imgArr.push(dataURL);
        let data = {
          modeCode: "DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M",
          sessionId: sessionId,
          // sessionId: '01e9da98-b81f-4eea-84c1-8472302399ca',
          userId: userId,
          userId: 'bc4a40d8-1de3-d450-7bfa-263ba14dadaa',
          fileName: encodeURIComponent(image.name),
          ocrType: 0,
          group: "other", //其他分组
          sendRabbitMsg: 1
        };
        let base64 = encodeURIComponent(dataURL);
        that.$http.upload(data, base64).then((res) => {
          that.toastStatus = false;
          if (res.code == 1) {
            that.list.push(res.msg);
            that.$Message.success("上传成功");
          } else {
            that.$Message.error("上传失败");
          }
        });
      };
    },
    repetitionUpload: function () {
      this.show = 0;
      this.imgArr = [];
      this.list = [];
    }
  }
}
</script>

<style lang="less" scoped>
main > div > div:nth-of-type(2n) {
  margin-left: calc(100vw - 356px);
}
/deep/.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
  z-index: 999;
}

/deep/.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.upload {
  width: 100vw;
  height: 100vh;
  position: relative;

  .toast {
    width: 100vw;
    height: 100vh;
    // border: 1px solid gray;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 150px;
      // height: 150px;
      border-radius: 8px;
      // background-color: rgba(0, 0, 0, 0.4);
    }
  }

  header {
    width: 100vw;
    height: 45px;
    line-height: 45px;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    // font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0.26px;
    background: #2c59c3;
    font-weight: 800;
  }

  main {
    width: 100vw;
    height: calc(100vh - 90px);
    overflow-y: scroll;
    background-color: white;
    position: absolute;
    top: 45px;
    left: 0;

    .successBox {
      text-align: center;

      img {
        margin-top: 114px;
      }
    }

    .failBox {
      text-align: center;

      img {
        margin-top: 114px;
      }

      p {
        margin-bottom: 146px;
      }

      div {
        width: 200px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border: 2px solid #3d8ff7;
        border-radius: 49.5px;
        color: #3d8ff7;

        margin: 0 auto;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #3d8ff7;
        letter-spacing: 0;
      }
    }

    .box {
      width: 100vw;
      padding: 16px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .imgbox {
        width: 47%;
        // height: 45%;
        height: 162px;
        background-color: #f8f8f8;
        position: relative;

        margin-bottom: 15px;

        .imgbox_son1 {
          width: 100%;
          height: 162px;
          position: absolute;
          top: 0;
          left: 0;
        }

        .imgbox_son2 {
          position: absolute;
          top: -9px;
          right: -9px;
        }
      }

      .cameraBox {
        width: 47%;
        height: 162px;
        background-color: #f8f8f8;
        position: relative;
        margin-bottom: 15px;

        input {
          width: 100%;
          height: 162px;
          opacity: 0;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 100;
        }

        .cameraBox_son {
          width: 100%;
          height: 162px;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          div {
            font-family: PingFangSC-Regular;
            font-size: 10px;
            color: #e4e4e4;
            letter-spacing: 0.19px;
            margin-top: 15px;
          }
        }
      }
    }
  }

  footer {
    width: 100vw;
    height: 45px;
    line-height: 45px;
    text-align: center;
    position: fixed;
    left: 0;
    bottom: 0;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0.26px;
    background: #2c59c3;
  }
}
</style>
